import { deletePricingVehicleRequest } from "../../data/pricingVehicleApi";

export async function deletePricingVehicleUseCase(id) {
  if (!id) {
    throw new Error("El id es obligatorio.");
  }

  return await deletePricingVehicleRequest(id);
}
